import styled from 'styled-components';

const ListItemWrapper = styled.div<{
  isSelected?: boolean;
  isLast?: boolean;
}>`
  height: 56px;
  width: 100%;

  border-bottom: 1px solid var(--color-border-secondary);

  ${(props) => props.isLast && `box-shadow: unset;`}
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;

  padding: 0px 12px;
  gap: 8px;

  a {
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .showOnMouseOver {
    visibility: ${process.env.NODE_ENV === 'test' ? '' : 'hidden'};
  }

  &:hover {
    background-color: var(--color-bg-muted);

    .showOnMouseOver {
      visibility: visible;
    }
  }
`;

export default ListItemWrapper;
